<script>
    import Spinner from 'vue-simple-spinner';
    import {Form} from '../../helpers/Form/Form'
    import {Gtag} from '../../mixins/ga'

    export default {
        mixins: [Gtag],
        props: {
            source: String
        },
        components: {Spinner},
        data() {
            return {
                showNote: false,
                form: new Form({
                    notification_cause: '',
                    note: ''
                })
            }
        },
        watch: {
            'form.notification_cause': function (val) {
                if (val == 'other') {
                    this.$set(this, 'showNote', true)
                } else {
                    this.$set(this, 'showNote', false)
                }
            }
        },
        mounted() {
            // $("#notifyModal").on('shown.bs.modal', () => {
            //     gtag('event', 'Form', {
            //         'event_category': 'InvitiSport',
            //         'event_label': '#segnala_InvitoSport'
            //     });
            // })
        },
        methods: {
            onSubmit() {
                this.form
                    .submit('post', this.source)
                    .then(response => {
                        if (window.isMobile()) {
                            this.sendGaEvent(
                                'Segnalazione',
                                'Corsi',
                                '#segnalazione-invia-mobile'
                            )
                        } else {
                            this.sendGaEvent(
                                'Segnalazione',
                                'Corsi',
                                '#segnalazione-invia'
                            )
                        }

                        $('#notifyModal').modal('hide');
                        window.alerts.success('Segnalazione inviata correttamente');
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseNotificationForm.vue